export default theme => ({
    twoColWrapper: {
        position: 'relative',
        marginBottom: 36,
    },
    twoColWrapperTheme: {
        // ...theme.twoColWrapperTheme,
    }
})